import { V2, addV2 } from './V2';

export interface AABB {
  position: V2,
  size: V2,
}

export const moveAABB = (aabb: AABB, amount: V2): AABB => ({
  position: addV2([...aabb.position], amount),
  size: aabb.size,
});
